import { ValueType } from "recharts/types/component/DefaultTooltipContent";

export function ProgressTooltip({
  active,
  payload,
  label,
}: {
  active?: boolean;
  payload?: Array<{ dataKey?: string; value?: ValueType }>;
  label?: string;
}) {
  if (!active) {
    return null;
  }

  const byKey = new Map<string, number>();
  (payload || []).forEach((item) => {
    if (!item?.dataKey) {
      return;
    }

    const parsed =
      typeof item.value === "number" ? item.value : Number(item.value ?? NaN);
    if (!Number.isNaN(parsed)) {
      byKey.set(item.dataKey, parsed);
    }
  });

  const planned = byKey.get("planned");
  const actual = byKey.get("actualAyatPct");
  const forecast = byKey.get("forecastAyatPct");

  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #e5e7eb",
        borderRadius: 8,
        padding: "8px 10px",
        boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
        width: "230px",
        position: "relative",
        zIndex: 9999,
        pointerEvents: "none",
      }}
    >
      {label ? (
        <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 6 }}>{label}</div>
      ) : null}
      <div style={{ fontSize: 13, color: "#2563eb", marginBottom: 8 }}>
        <div>Planlagt fremdrift: {planned !== undefined ? `${planned}%` : "-"}</div>
        <div style={{ fontSize: 12, color: "#2563eb", marginTop: 2 }}>
          Planned progress: {planned !== undefined ? `${planned}%` : "-"}
        </div>
        <div style={{ fontSize: 12, color: "#2563eb", marginTop: 2, direction: "rtl", textAlign: "right" }}>
          التقدم المخطط: {planned !== undefined ? `${planned}%` : "-"}
        </div>
      </div>

      <div style={{ fontSize: 13, color: "#f59e0b", marginBottom: 8 }}>
        <div>Faktisk fremdrift: {actual !== undefined ? `${actual}%` : "-"}</div>
        <div style={{ fontSize: 12, color: "#f59e0b", marginTop: 2 }}>
          Actual progress: {actual !== undefined ? `${actual}%` : "-"}
        </div>
        <div style={{ fontSize: 12, color: "#f59e0b", marginTop: 2, direction: "rtl", textAlign: "right" }}>
          التقدم الفعلي: {actual !== undefined ? `${actual}%` : "-"}
        </div>
      </div>

      <div style={{ fontSize: 13, color: "#16a34a" }}>
        <div>Forventet fremdrift: {forecast !== undefined ? `${forecast}%` : "-"}</div>
        <div style={{ fontSize: 12, color: "#16a34a", marginTop: 2 }}>
          Forecast progress: {forecast !== undefined ? `${forecast}%` : "-"}
        </div>
        <div style={{ fontSize: 12, color: "#16a34a", marginTop: 2, direction: "rtl", textAlign: "right" }}>
          التقدم المتوقع: {forecast !== undefined ? `${forecast}%` : "-"}
        </div>
      </div>
    </div>
  );
}